import React from "react";
import Navbar from "../layouts/Navbar";

import Mission from "../layouts/Mission";
import Aboutus from "../layouts/Aboutus";
import Ourteam from "../layouts/Ourteam";
import Footer from "../layouts/Footer";
export default function AboutUs() {
  return (
    <>
      <Navbar />
      <Mission />
      <Aboutus />
      <Ourteam />
      <Footer />
    </>
  );
}
